import React from 'react';
import { Box } from '@mui/material';
import {
    TrialRunModalFooterProps,
    trialRunModalStyles,
} from './trial-run-modal-helper';
import { Button } from '@biq/apex-ui';

export const TrialRunModalFooter = ({
    isResultVisible,
    handleRunClick,
}: TrialRunModalFooterProps): React.JSX.Element => {
    return (
        <Box
            sx={{
                ...trialRunModalStyles.buttonContainer,
                mt: isResultVisible ? 2.25 : 2,
            }}
        >
            <Button
                autoFocus
                color='primary'
                variant='contained'
                size='small'
                onClick={handleRunClick}
                sx={{ ...(!isResultVisible && { width: '110px' }) }}
            >
                {isResultVisible ? 'Start Over' : 'Run'}
            </Button>
        </Box>
    );
};
